export const routes = {
  billing: {
    home: '/billing-tool',
    main: '/billing-tool/client-insurer',
    tool: '/billing-tool/tool',
    clientInsurerPath: 'client-insurer',
    clientInsurerId: ':id',
    // package
    fullNewContractPackagePath: '/client-insurer/:id/contract/package/new',
    newContractPackage: 'contract/package/new',
    fullEditContractPackagePath:
      '/client-insurer/:id/contract/package/:contractId/edit',
    editContractPackageContract: 'contract/package/:contractId/edit',
    fullBatchContractCreateStatus:
      '/client-insurer/batch-create-contract/status',
    batchContractCreateStatus: 'batch-create-contract/status',
    batchContractCreate: '/client-insurer/batch-create-contract',
    discountCalculator: 'discount-calculator',
    clientPath: 'client',
    clientId: ':id',
    userPath: 'user',
    userId: ':id',
    billManagement: '/bills',
    submissionsManagement: '/submissions',
    holdsAggregate: '/bills/aggregate-holds',
    programCaps: '/program-caps',
    batchProgramCapImport: '/program-caps/batch-import',
    unbilledReport: '/bills/unbilled-report',
    clientFeeSchedules: '/fee-schedules/client',
    partnershipFeeSchedules: '/fee-schedules/partnership',
    esiFeeSchedules: '/fee-schedules/esi',
    cvsFeeSchedules: '/fee-schedules/cvs',
    procedureCodes: '/procedure-codes',
    icdCodes: '/icd-codes',
    revenueShares: '/revenue-shares',
    packages: '/packages',
    volumeBasedDiscounts: '/volume-based-discounts',
    eligibilityVerifier: '/eligibility-verifier',
    csvUpload: '/csv-uploader',
  },
};
